import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectSaved, selectSaving, selectStudent } from '../selectors/student.selector';
import { studentActions } from '../actions/student.actions';
import { StudentCreateValue, StudentUpdateValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class StudentFacade {
    private store = inject(Store);

    // --- Observable accessors ---

    readonly student$ = (id: string) => this.store.select(selectStudent(id));
    readonly studentNonNullable$ = (id: string) => this.store.select(selectStudent(id)).pipe(filter((student) => student !== null));

    readonly loaded$ = (id: string) => this.store.select(selectLoaded(id));
    readonly loadedNonNullable$ = (id: string) => this.store.select(selectLoaded(id)).pipe(filter((loaded) => loaded !== null));

    readonly loading$ = (id: string) => this.store.select(selectLoading(id));

    readonly saved$ = this.store.select(selectSaved);
    readonly savedNonNullable$ = this.store.select(selectSaved).pipe(filter((saved) => saved !== null));
    readonly saving$ = this.store.select(selectSaving);

    // --- Signal accessors ---

    readonly student = (id: string) => this.store.selectSignal(selectStudent(id));
    readonly loaded = (id: string) => this.store.selectSignal(selectLoaded(id));
    readonly loading = (id: string) => this.store.selectSignal(selectLoading(id));

    getStudent(id: string): void {
        this.store.dispatch(studentActions.getStudent({ id }));
    }

    addStudent(value: StudentCreateValue): void {
        this.store.dispatch(studentActions.addStudent({ value }));
    }

    updateStudent(id: string, value: StudentUpdateValue): void {
        this.store.dispatch(studentActions.updateStudent({ id, value }));
    }

    deleteStudent(id: string): void {
        this.store.dispatch(studentActions.deleteStudent({ id }));
    }

    clear(): void {
        this.store.dispatch(studentActions.clear());
    }
}
